import React, { useState, useEffect } from "react"
import RMOPendingAppointmentComponent from "../AppointmentsPage/components/RMOPendingAppointmentComponent"
import PatientDirectory from "../frontDesk/patientDirectory/PatientDirectory"
import "./MrdPage.scss"
import { getAllCenters } from "core/services/api"
import Select from "react-select"

function MrdPage() {
  const [location, setLocation] = useState<any>("")
  const [centers, setCenters] = useState<any>([])

  useEffect(() => {
    getAllCenters()
      .then((res: any) => {
        const tempCenters: any = res?.map((each: any) => {
          return { label: each?.centerName, value: each?.id }
        })
        setCenters(tempCenters)
      })
      .catch((err: any) => {
        console.log(err)
      })
  }, [])

  return (
    <div className="mrd-parent-container">
      <div className="mrd-header">
        <div className="sort-filter-section">
        </div>
      </div>
      <RMOPendingAppointmentComponent />
      <div className="location-dropdown-container">
        <div className="location-dropdown-inner-container">
        </div>
        <div className="location-dropdown-inner-container">
          {/* <div className="select-location-label">Location: </div> */}
          <Select
            styles={{
              control: (provided, state) => ({
                ...provided,
                border: "1px solid #ccd0e7",
                borderRadius: "10px"
              })
            }}
            options={centers}
            onChange={(option: any) => {
              setLocation(option?.value)
            }}
            placeholder="Select Center..."
            value={centers?.filter(({ value }: any) => value === location)}
          />
        </div>
      </div>
      <div className="content-wrapper">
        <PatientDirectory
          selectedCenter={location}
        />
      </div>
    </div>
  )
}

export default MrdPage
